import _ from 'lodash';
const now = new Date();
const nowYear = now.getFullYear();
export const POSITION_CANDIDATE_OTHER = {
    label: 'その他',
    other: true,
    value: 8,
};
export const POSITION_CANDIDATES = [
    { label: '経営者・役員クラス', value: 1 },
    { label: '本部長クラス', value: 2 },
    { label: '部長クラス', value: 3 },
    { label: '課長クラス', value: 4 },
    { label: '係長・主任クラス', value: 5 },
    { label: '一般社員・職員クラス', value: 6 },
    { label: '契約・嘱託・派遣', value: 7 },
    POSITION_CANDIDATE_OTHER,
];
export const OCCUPATION_CANDIDATE_OTHER = {
    label: 'その他',
    other: true,
    value: 15,
};
export const OCCUPATION_CANDIDATES = [
    { label: '経営者・役員', value: 1 },
    { label: '経営企画・事業開発', value: 2 },
    { label: '調査・マーケティング', value: 3 },
    { label: '営業・販売', value: 4 },
    { label: '生産・製造', value: 5 },
    { label: '購買・物流', value: 6 },
    { label: '研究・開発・設計', value: 7 },
    { label: '労務・人事・総務', value: 8 },
    { label: '法務・ガバナンス', value: 9 },
    { label: '情報システム・ITエンジニア', value: 10 },
    { label: 'デザイン・クリエイティブ', value: 11 },
    { label: 'IR・広報・CSR', value: 12 },
    { label: '経理・財務', value: 13 },
    { label: '専門職（弁護士・公認会計士等）', value: 14 },
    OCCUPATION_CANDIDATE_OTHER,
];
export const PROFESSIONAL_POSITION_CANDIDATES = [
    { label: '社長/CEO', value: 1 },
    { label: 'パートナークラス', labelBr: 'パートナー\nクラス', value: 2 },
    { label: 'ディレクタークラス', labelBr: 'ディレクター\nクラス', value: 3 },
    { label: 'マネージャークラス', labelBr: 'マネージャー\nクラス', value: 4 },
    {
        label: 'シニアコンサルタントクラス',
        labelBr: 'シニアコンサルタント\nクラス',
        value: 5,
    },
    { label: 'ジュニアスタッフ', value: 6 },
    { label: 'その他', other: true, value: 7 },
];
export const SITUATION_CANDIDATES = [
    { label: '対応可能', value: 1 },
    { label: '要相談', value: 2 },
    { label: '対応不可', value: 3 },
];
export const GENDER_CANDIDATES = [
    { label: '男性', value: 1 },
    { label: '女性', value: 2 },
];
export const SKILL_CANDIDATES = [
    { label: '定量分析力', value: 1 },
    { label: '定性分析力（インタビュー・リサーチ）', value: 2 },
    { label: '発想力（斬新な視点の提供）', value: 3 },
    { label: 'ファシリテーション力', value: 4 },
    { label: '経営層との対話力（コーチング力）', value: 5 },
    { label: 'グローバルチームのマネジメント力', value: 6 },
    { label: '資料作成力（魅せ方）', value: 7 },
    { label: 'プレゼン力（伝え方）', value: 8 },
    { label: '現場に落とし込む力', value: 9 },
    { label: '豊富な経験に基づく実践面の指導力', value: 10 },
    { label: '有識者のネットワーク力', value: 11 },
    { label: '社会トレンドに関する知見', value: 12 },
    { label: '経済動向・世界情勢における知見', value: 13 },
    { label: '特定技術領域の知見', value: 14 },
    { label: '特定地域における知見', value: 15 },
];
export const FREE_UNIT_CANDIDATES = [
    { label: '日', value: 1 },
    { label: '時間', value: 2 },
];
export const FREE_SITUATION_CANDIDATES = [
    { label: '実施可能', value: 1 },
    { label: '対応時期要相談', value: 2 },
    { label: '対応不可', value: 3 },
];
export const FREE_ON_SITE_CANDIDATES = [
    { label: 'OK', value: 1 },
    { label: 'NG', value: 2 },
    { label: '要相談', value: 3 },
];
export const FREE_CAREER_CHANGE_CANDIDATES = [
    { label: 'あり', value: 1 },
    { label: 'なし', value: 2 },
];
export const CAREER_YEAR_VALUES = _.range(100).map((ignore, i) => ({
    label: (nowYear - i).toString(),
    value: (nowYear - i).toString(),
}));
export const CAREER_MONTH_VALUES = _.range(12).map((ignore, i) => ({
    label: (1 + i).toString(),
    value: (1 + i).toString(),
}));
export const CAREER_YEAR_DEFAULT_VALUE = nowYear.toString();
export const CAREER_MONTH_DEFAULT_VALUE = (now.getMonth() + 1).toString();
// 各種権限
export const SERVICE_PROFFIT_SEARCH = 'SERVICE_PROFFIT_SEARCH';
export const SERVICE_PROFESSIONAL_PROFFIT = 'SERVICE_PROFESSIONAL_PROFFIT';
export const SERVICE_PROFESSIONAL_PROFFIT_MART = 'SERVICE_PROFESSIONAL_PROFFIT_MART';
export const SERVICE_CLIENT_PROFFIT = 'SERVICE_CLIENT_PROFFIT';
export const SERVICE_SEMINAR_ENABLE = 'SERVICE_SEMINAR_ENABLE';
export const TWO_FACTOR_AUTHENTICATION = 'TWO_FACTOR_AUTHENTICATION';
